<ft-initialized-content [isInitialized]="isInitialized()">
    <section class="ft-master-section ft-cooperative-bigpicture-master">
        <section class="ft-section ft-bigpicture-section">
            <div class="ft-container">
                <ft-daterange-picker (changed)="onCalendarDateRangeChange($event)" [storageKey]="'cooperative.bigpicture'" />
                <div class="ft-bigpicture-share">
                    <div class="ft-row">
                        <div class="ft-col-50">
                            <div class="ft-datastory">
                                <p class="ft-count ft-text-plus-8">{{ propertiesStatistics()?.Advocates?.GrandTotal | number }}</p>
                                <p class="ft-count-label ft-text-plus-3">advocates</p>
                                <p class="ft-text-plus-1">
                                    shared their excitement for traveling to your destination.
                                </p>
                            </div>
                        </div>
                        <div class="ft-col-50">
                            <table class="ft-chart ft-tablechart">
                                <thead></thead>
                                <tfoot></tfoot>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <div class="ft-tbody-scroll">
                                                <table>
                                                    @for (property of propertiesStatistics()?.Advocates?.Properties; track property) {
                                                        <tr class="ft-datapoint">
                                                            <td>
                                                                <div class="ft-label">{{ property.Name }}</div>
                                                            </td>
                                                            <td>
                                                                <div class="ft-count">{{ property.Total | percentage:propertiesStatistics()?.Advocates?.GrandTotal | number:2 }}
                                                                    %
                                                                </div>
                                                                <div class="ft-meter">
                                                                    <div class="ft-fill" [style.width.%]="property.Total | percentage:firstTotal(propertiesStatistics()?.Advocates?.Properties)"></div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="ft-bigpicture-reach">
                    <p class="ft-text-plus-2">Those advocates helped your cooperative reach</p>
                    <p class="ft-count ft-text-plus-10">{{ propertiesStatistics()?.Reach?.GrandTotal | number }}</p>
                    <p class="ft-count-label ft-text-plus-3">people worldwide</p>
                    <p>
                        and brought
                        <span class="ft-emphasis">{{ propertiesStatistics()?.Visitors?.GrandTotal | number }} unique
                            visitors
                        </span>
                        to web experiences for your cooperative.
                    </p>
                </div>
                <div class="ft-bigpicture-leads">
                    <div class="ft-row">
                        <div class="ft-col-50">
                            <div class="ft-datastory">
                                <p class="ft-count ft-text-plus-8">{{ propertiesStatistics()?.Signups?.GrandTotal | number }}</p>
                                <p class="ft-count-label ft-text-plus-3">warm leads</p>
                                <p class="ft-text-plus-1">
                                    showed interest in future travel to your destination.
                                </p>
                            </div>
                        </div>
                        <div class="ft-col-50">
                            <table class="ft-chart ft-tablechart">
                                <thead></thead>
                                <tfoot></tfoot>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <div class="ft-tbody-scroll">
                                                <table>
                                                    @for (property of propertiesStatistics()?.Signups?.Properties; track property) {
                                                        <tr class="ft-datapoint">
                                                            <td>
                                                                <div class="ft-label">{{ property.Name }}</div>
                                                            </td>
                                                            <td>
                                                                <div class="ft-count">{{ property.Total | percentage:propertiesStatistics()?.Signups?.GrandTotal | number:'2' }}
                                                                    %
                                                                </div>
                                                                <div class="ft-meter">
                                                                    <div class="ft-fill" [style.width.%]="property.Total | percentage:firstTotal(propertiesStatistics()?.Signups?.Properties)"></div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        @if (propertiesStatistics()?.Nights?.GrandTotal > 0) {
            <section class="ft-section ft-bookings-breakdown-section">
                <div class="ft-section-bg"></div>
                <div class="ft-bigpicture-bookings ft-content">
                    <div class="ft-container">
                        <p class="ft-text-plus-2">
                            During this <span>{{ endDate() | daysUntilDate:startDate() }}-day period</span>,
                            at least <span class="ft-emphasis">{{ propertiesStatistics()?.Nights?.GrandTotal | number }} room nights were booked</span>
                            that can be attributed to Advocacy for your Marketing Cooperative.
                        </p>
                    </div>
                </div>
            </section>
        }
    </section>
</ft-initialized-content>
